/**
 * PUBSUB SYSTEM - CORE DEPENDENCY
 * Provides event system for cart modules
 * Ensures single source of truth for all dependencies
 */

// Prevent duplicate loading
if (window.PUBSUB_LOADED) {
  console.log('⚠️ PubSub already loaded, skipping...');
} else {
  window.PUBSUB_LOADED = true;
  
  let subscribers = {};

  function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
      subscribers[eventName] = [];
    }

    subscribers[eventName] = [...subscribers[eventName], callback];

    return function unsubscribe() {
      subscribers[eventName] = subscribers[eventName].filter((cb) => {
        return cb !== callback;
      });
    };
  }

  function publish(eventName, data) {
    if (subscribers[eventName]) {
      const promises = subscribers[eventName]
        .map((callback) => callback(data))
      return Promise.all(promises);
    } else {
      return Promise.resolve()
    }
  }

  // Make functions globally available for cart system
  window.subscribe = subscribe;
  window.publish = publish;

  // Add essential global dependencies with conflict prevention
  if (!window.debounce) {
    window.debounce = function(fn, wait) {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(this, args), wait);
      };
    };
  }

  // Add routes object with conflict prevention
  if (!window.routes) {
    window.routes = {
      cart_url: '/cart',
      cart_add_url: '/cart/add',
      cart_change_url: '/cart/change',
      cart_update_url: '/cart/update'
    };
  }

  // Add fetchConfig function with conflict prevention
  if (!window.fetchConfig) {
    window.fetchConfig = function(type = 'json') {
      return {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/${type}`,
          'X-Requested-With': 'XMLHttpRequest'
        }
      };
    };
  }

  // Add PubSub events with conflict prevention
  if (!window.PUB_SUB_EVENTS) {
    window.PUB_SUB_EVENTS = {
      cartUpdate: 'cart-update',
      quantityUpdate: 'quantity-update',
      cartError: 'cart-error'
    };
  }

  // Add debounce timer with conflict prevention
  if (!window.ON_CHANGE_DEBOUNCE_TIMER) {
    window.ON_CHANGE_DEBOUNCE_TIMER = 300;
  }

  console.log('✅ PubSub system and global dependencies loaded');
}
